export default "__VITE_ASSET__Cak2XPqi__"